/**
 * TipoOcorrencia
 * @author Simpli CLI generator
 */
import { $, HttpBody, ID, Resource, ResponseSerialize, TAG } from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import TipoVeiculoSchema from '@/schema/TipoVeiculo.schema'

export default class TipoVeiculo extends Resource {

  static getTipoVeiculoByName(name: string, spinner = 'getTipoVeiculoByName') {
    const fetch = async () => await new HttpBody(Array).GET(`/user/tipo-veiculo/get-nome/${name}`)
    return $.await.run(fetch, spinner)
  }

  get $schema() {
    return TipoVeiculoSchema(this)
  }

  get $id() {
    return this.idTipoVeiculo
  }
  set $id(val: ID) {
    this.idTipoVeiculo = val
  }
  get $tag() {
    return this.nome
  }
  set $tag(val: TAG) {
    this.nome = val
  }

  idTipoVeiculo: ID = 0

  readonly $name: string = 'TipoVeiculo'

  readonly $endpoint: string = '/user/tipo-veiculo{/id}'

  @ValidationRequired()
  @ValidationMaxLength(100)
  nome: string = ''

  @ValidationRequired()
  ativo: boolean = false

  @ValidationRequired()
  ehDevolvida: boolean = false

  async getTipoVeiculoById(id: ID, spinner = 'getTipoVeiculoById') {
    const fetch = async () => await this.GET(`/user/tipo-veiculo/${id}`)
    return await $.await.run(fetch, spinner)
  }

  async getTipoVeiculo(spinner = 'getTipoVeiculo') {
    const fetch = async () => await this.GET(`/user/tipo-veiculo`)
    return await $.await.run(fetch, spinner)
  }

}
